/* eslint-disable */
import Vue from 'vue'
import moment from 'moment'
import { money } from '@/utils/filters'
import variables from '@/utils/variables'
import _ from 'lodash'

export function getReceiptCss() {
  return `
  body {
    font-size: 12px;
  }

  table {
    border-collapse: collapse; 
  }

  table thead tr {
    border-bottom: 1px solid black;
    border-top: 1px solid black;
    font-weight: bold;
    padding-bottom: 2px;
    padding-top: 2px;
  }

  .bar {
    border-bottom: 1px solid black;
    border-top: 1px solid black;
    padding-bottom: 2px;
    padding-top: 2px;
  }

  .text-xs-left {
    text-align: left;
  }

  .text-xs-center {
    text-align: center;
  }

  .text-xs-right {
    text-align: right;
  }

  .font-size-xs {
    font-size: 10px;
  }
    
  .font-size-sm {
    font-size: 11px;
  }

  .font-size-md {
    font-size: 12px;
  }

  .font-size-lg {
    font-size: 13px;
  }

  .font-weight-bold {
    font-weight: bold;
  }

  .text-uppercase {
    text-transform: uppercase;
  }
`
}

export function getReportLogo(report) {
  const storeLogoUrl = _.get(report, 'cashRegister.store.storeReceiptLogoUrl') || `${variables.baseUrl}/static/images/vaporshop-logo-receipt.jpg`
  const logo = [
    `\x1B\x61\x31`, // center align
    {
      type: 'raw',
      format: 'image',
      data: storeLogoUrl,
      options: {
        language: 'ESCPOS',
        dotDensity: 'double'
      }
    }
  ]

  return logo
}

export function getReportHtml(report) {
  const html = /*html*/`
    <html>
      <style>
        ${getReceiptCss()}
      </style>

      <div class="bar font-size-md font-weight-bold text-xs-center text-uppercase">
        ${Vue.i18n.translate('Register Closure')}<br/>
        #${report.nr}
      </div>

      <table width="100%" class="font-size-sm">
        <tr>
          <td class="font-weight-bold">${Vue.i18n.translate('Store')}:</td>
          <td>${report.cashRegister.store.name}</td>
        </tr>
        <tr>
          <td class="font-weight-bold">${Vue.i18n.translate('Cash Register')}</td>
          <td>${report.cashRegister.description}</td>
        </tr>
        <tr>
          <td class="font-weight-bold">${Vue.i18n.translate('Opened')}:</td>
          <td>${moment(report.created).format('D MMMM YYYY HH:mm')}</td>
        </tr>
        <tr>
          <td class="font-weight-bold">${Vue.i18n.translate('Closed')}:</td>
          <td>${moment(report.closed).format('D MMMM YYYY HH:mm')}</td>
        </tr>
      </table>

      <h3>${Vue.i18n.translate('Cash Movements')}</h3>
      <table width="100%">
        <colgroup>
          <col width="25%">
          <col width="25%">
          <col width="25%">
          <col width="25%">
        </colgroup>
        <thead class="font-size-md">
          <tr>
            <th class="text-xs-left">${Vue.i18n.translate('Time')}</th>
            <th class="text-xs-left">${Vue.i18n.translate('Employee')}</th>
            <th class="text-xs-left">${Vue.i18n.translate('Note')}</th>
            <th class="text-xs-left">${Vue.i18n.translate('Amount')}</th>
          </tr>
        </thead>
        <tbody class="font-size-sm">
          ${Object.keys(report.cashMovements).map(key => (
    `
            <tr>
              <td>${moment(report.cashMovements[key].created).format('D MMMM YYYY HH:mm')}</td>
              <td>${report.cashMovements[key].creator.screenName}</td>
              <td>${report.cashMovements[key].note || '-'}</td>
              <td>${money(report.cashMovements[key].amount)}</td>
            </tr>
            `)).join('')}
        </tbody>
      </table>

      <h3>${Vue.i18n.translate('Payments')}</h3> 
      <table width="100%">
        <colgroup>
          <col width="25%">
          <col width="25%">
          <col width="25%">
          <col width="25%">
        </colgroup>
        <thead class="font-size-md">
          <tr>
            <th class="text-xs-left">${Vue.i18n.translate('Payment Method')}</th>
            <th class="text-xs-left">${Vue.i18n.translate('Expected')}</th>
            <th class="text-xs-left">${Vue.i18n.translate('Counted')}</th>
            <th class="text-xs-left">${Vue.i18n.translate('Difference')}</th>
          </tr>
        </thead>
        <tbody class="font-size-sm">
         ${Object.keys(report.cashRegisterPaymentCounts).map(key => (
      `
            <tr>
              <td>                
              ${report.cashRegisterPaymentCounts[key].paymentMethod.name}
              </td>
              <td>${money(report.cashRegisterPaymentCounts[key].expected)}</td>
              <td>${money(report.cashRegisterPaymentCounts[key].counted)}</td>
              <td>${money(report.cashRegisterPaymentCounts[key].difference)}</td>
            </tr>
            `)).join('')}
        </tbody>
        <tfoot class="font-size-sm">
        <tr>
          <td class="text-caption font-weight-bold">${Vue.i18n.translate('Totals')}</td>
          <td class="text-caption font-weight-bold">${money(report.cashRegisterPaymentCounts.reduce((accumulator, count) => accumulator + count.expected, 0))}</td>
          <td class="text-caption font-weight-bold">${money(report.cashRegisterPaymentCounts.reduce((accumulator, count) => accumulator + count.counted, 0))}</td>
          <td class="text-caption font-weight-bold">${money(report.cashRegisterPaymentCounts.reduce((accumulator, count) => accumulator + count.difference, 0))}</td>
          </tr>
      </table>

      <div class="text-xs-center font-size-xs">
        <p>${report.cashRegister.store.businessName} | ${report.cashRegister.store.businessNr} <br/>
        ${report.cashRegister.store.email} | ${report.cashRegister.store.phone}</p>
      </div>
    </html>`

  return [{
    type: 'pixel',
    format: 'html',
    flavor: 'plain',
    data: html
  }]
}

export function getReportQR(report) {
  const qr = report.nr

  // QR Dot Size
  const dots = `\x05`
  // QR proprietary size calculation
  const size1 = String.fromCharCode(qr.length + 3)
  const size0 = `\x00`

  // Create the QR Code
  return [
    `\x1B\x61\x31`, // center align
    // <!-- BEGIN QR DATA -->
    `\x1D\x28\x6B\x04\x00\x31\x41\x32\x00`,
    `\x1D\x28\x6B\x03\x00\x31\x43${dots}`,
    `\x1D\x28\x6B\x03\x00\x31\x45\x30`,
    `\x1D\x28\x6B${size1}${size0}\x31\x50\x30${qr}`,
    `\x1D\x28\x6B\x03\x00\x31\x51\x30`,
    `\x1D\x28\x6B\x03\x00\x31\x52\x30`
    // <!-- END QR DATA -->
  ]
}


// WEBPACK FOOTER //
// ./src/utils/report-layout.js